import { createRouter, createWebHistory } from 'vue-router'
import DefaultLayout from '../layouts/DefaultLayout.vue'

// Import Guard
import { authGuard } from './guards/authGuard'

// Import Route Modules
import { publicRoutes } from './routes/public'
import { dashboardRoutes } from './routes/dashboard'
import { hrRoutes } from './routes/hr'
import { adminRoutes } from './routes/admin'
import { operationsRoutes } from './routes/operations'
import { financeRoutes } from './routes/finance'
import { reportingRoutes } from './routes/reporting'

const routes = [
  ...publicRoutes,
  {
    path: '/',
    component: DefaultLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'root',
        component: () => import('../components/EmptyRouteComponent.vue')
      },
      ...dashboardRoutes,
      ...hrRoutes,
      ...operationsRoutes,
      ...financeRoutes,
      ...reportingRoutes,
      ...adminRoutes
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(authGuard)

export default router